import { Injectable, ErrorHandler } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { NotificationService } from '../notifications/notification.service'

@Injectable()
export class AppErrorHandler extends ErrorHandler {
  constructor(private notificationsService: NotificationService) {
    super()
  }

  override handleError(error: Error | HttpErrorResponse) {
    // Default fallback message
    let displayMessage = 'An error occurred.'

    if (error instanceof HttpErrorResponse) {
      // 🧩 Handle AI backend 404 cases (missing API key or missing model)
      if (error.status === 404 && this.isAIRequest(error.url)) {
        const endpoint = error.url ?? ''

        if (endpoint.includes('/get-key')) {
          this.notificationsService.warn(
            '⚠️ No API key configured. Please add your API key to use AI features.'
          )
        } else if (endpoint.includes('/get-model')) {
          this.notificationsService.warn(
            '⚠️ No model selected. Please select a model to use AI features.'
          )
        } else {
          // Fallback for other AI endpoints returning 404
          this.notificationsService.warn(
            '⚠️ Resource not found for AI features.'
          )
        }

        return // Stop further propagation since we handled it
      }

      // 🧩 Generic HTTP error message
      displayMessage += ` ${error.status} - ${error.message}`
    } else {
      // 🧩 Non-HTTP error (client-side or coding error)
      displayMessage += ` ${error.message}`
    }

    if (!environment.production) {
      displayMessage += ' See console for details.'
    }

    // 🧩 Generic fallback notification
    this.notificationsService.error(displayMessage)

    // Log to console
    super.handleError(error)
  }

  /**
   * Helper to identify if the failing request is one of your OpenAI backend endpoints.
   * Adjust the string to match your backend route.
   */
  private isAIRequest(url: string | null): boolean {
    return !!url && url.includes('/openai-config')
  }
}
